import request from '@/utils/request';
import exportFile from '@/utils/export';

export function getDictList(data) {
  return request({ url: '/sys/dict/queryByCode', method: 'get', params: data });
}



// WEBPACK FOOTER //
// ./src/api/dict.js